import recognizeIndex from "@/views/recognize/recognizeIndex.vue";



export default {
  path: "/recognize",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "recognizeIndex",
      name: "recognizeIndex",
      component: recognizeIndex,
    },

  ],
};
